/**
 * Environment config selector — driven by VITE_ENV build-time variable.
 * Set via --mode flag: `vite build --mode dev` loads .env.dev → VITE_ENV=dev
 *
 * Usage:  import { environment } from '@web/config';
 */
import { environment as localEnv } from './environment';
import { environment as devEnv } from './environment.dev';
import { environment as intEnv } from './environment.int';
import { environment as stageEnv } from './environment.stage';
import { environment as prodEnv } from './environment.prod';
import { environment as externalDevEnv } from './environment.externaldev';
import { environment as externalIntEnv } from './environment.externalint';
import { environment as externalStageEnv } from './environment.externalstage';
import { environment as externalProdEnv } from './environment.externalprod';
import type { Environment } from './environment';

const viteEnv = import.meta.env.VITE_ENV as string ?? 'local';
const envMap: Record<string, Environment> = {
  local: localEnv,
  dev: devEnv,
  int: intEnv,
  stage: stageEnv,
  prod: prodEnv,
  externaldev: externalDevEnv,
  externalint: externalIntEnv,
  externalstage: externalStageEnv,
  externalprod: externalProdEnv,
};

export const environment: Environment = envMap[viteEnv] ?? localEnv;

export type { Environment };
export { apiUrls } from './api-urls';
